module.exports = __webpack_public_path__ + "img/rugbyunion.da6960df.svg";